// extracted by mini-css-extract-plugin
export default {"root":"PublicLayout_root-CNl","secondary":"PublicLayout_secondary-Wrb","header":"PublicLayout_header-K90","secondaryHeader":"PublicLayout_secondaryHeader-lou"};